(function () {
  function initRobeliePdpContinuity() {
    var root = document.querySelector('.robelie-skims-buybox');
    if (!root || root.dataset.continuityReady === 'true') return;

    var variantsNode = root.querySelector('[data-variants-json]');
    var variants = [];
    try { variants = JSON.parse((variantsNode && variantsNode.textContent) || '[]'); } catch (error) { return; }
    if (!variants.length) return;

    root.dataset.continuityReady = 'true';

    var colorIndex = Number(root.dataset.colorIndex || 0);
    var collectionIndex = Number(root.dataset.collectionIndex || 2);
    var header = root.querySelector('.rb-skims__header');
    var title = root.querySelector('.rb-skims__title');
    var price = root.querySelector('.rb-skims__price');
    var collectionLabel = root.querySelector('.rb-skims__product-code');
    if (!header || !title || !price || !collectionLabel) return;

    var back = document.createElement('a');
    back.className = 'rb-pdp__back';
    back.href = (root.dataset.rootUrl || '/') + 'collections/robels';
    back.innerHTML = '<span class="rb-pdp__back-arrow" aria-hidden="true">←</span><span>Shop all colors</span>';
    header.insertBefore(back, header.firstChild);

    var headline = document.createElement('div');
    headline.className = 'rb-pdp__headline-row';
    header.insertBefore(headline, title);
    headline.appendChild(title);
    headline.appendChild(price);

    var descriptor = document.createElement('p');
    descriptor.className = 'rb-pdp__descriptor';
    descriptor.textContent = 'A towel. A robe, too.';
    headline.insertAdjacentElement('afterend', descriptor);

    var rule = root.querySelector('.rb-skims__rule');
    var firstColorGroup = root.querySelector('.rb-skims__color-group');
    var summary = document.createElement('div');
    summary.className = 'rb-pdp__selection-summary';
    summary.innerHTML = '<span class="rb-pdp__selection-summary-label">Color</span><span class="rb-pdp__selection-summary-value" data-pdp-selected-color></span>';
    if (rule && rule.parentNode) rule.insertAdjacentElement('afterend', summary);
    else if (firstColorGroup && firstColorGroup.parentNode) firstColorGroup.parentNode.insertBefore(summary, firstColorGroup);

    root.querySelectorAll('.rb-skims__color-group').forEach(function (group) {
      var label = group.querySelector('.rb-skims__group-heading > span');
      if (!label) return;
      label.textContent = group.dataset.colorGroup === 'fall' ? 'Limited Edition' : 'Classic Colors';
    });

    var fitHeading = root.querySelector('.rb-skims__size-heading > span');
    if (fitHeading) fitHeading.textContent = 'Fit';
    var fitChoices = root.querySelector('.rb-skims__sizes');
    if (fitChoices) fitChoices.setAttribute('aria-label', 'Choose a fit');

    function collectionName(value) {
      return String(value || '').toLowerCase().indexOf('fall') > -1 ? 'Fall Collection' : 'Classic Collection';
    }

    function update(variant) {
      if (!variant || !variant.options) return;
      var color = variant.options[colorIndex] || '';
      var collection = variant.options[collectionIndex] || '';
      title.textContent = color ? color + ' Robél' : 'Robél';
      collectionLabel.textContent = collectionName(collection);
      var selectedColor = root.querySelector('[data-pdp-selected-color]');
      if (selectedColor) selectedColor.textContent = color;
    }

    var initialId = null;
    try { initialId = new URL(window.location.href).searchParams.get('variant'); } catch (error) {}
    initialId = initialId || root.dataset.initialVariant;
    var initialVariant = variants.find(function (variant) { return String(variant.id) === String(initialId); }) || variants[0];
    update(initialVariant);

    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant) update(event.detail.variant);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRobeliePdpContinuity);
  else initRobeliePdpContinuity();

  document.addEventListener('shopify:section:load', initRobeliePdpContinuity);
})();
